import React from 'react';
import { branch, compose, renderNothing, withProps } from 'recompose';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import _ from 'lodash';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import {
  Button,
  Row,
  Col,
} from 'react-bootstrap';


import './style.css';
import omitProps from '../../utils/omitProps';
import { querySelector } from '../../utils';

const COLUMN_WIDTH = 2;


const propTypes = exact({
  /* eslint-disable react/no-unused-prop-types */
  selectedId: PropTypes.number.isRequired,
  uploadedFiles: PropTypes.array.isRequired,
  onTypeChange: PropTypes.func.isRequired,
  selectedIndex: PropTypes.number.isRequired,
  showConfirmModal: PropTypes.func.isRequired,
  selectIndex: PropTypes.func.isRequired,
});


const MultipageTypeLayout = (props) => {
  const {
    uploadedFiles,
    onTypeChange,
    selectedIndex,
    showConfirmModal,
    selectIndex,
  } = props;

  const renderColumn = (uploadedFile) => {
    let className = '';

    const { thumbnailUrl, pageIndex } = uploadedFile;

    if (selectedIndex === pageIndex) {
      className = 'bg-primary';
    }
    return (
      <Col style={{ cursor: 'pointer' }} key={pageIndex} className={className} onClick={() => { selectIndex(pageIndex); }} md={COLUMN_WIDTH}>
        <img height="100" width="100" src={thumbnailUrl} alt="submitted item" />
      </Col>
    );
  };

  const renderRows = () => {
    const rows = _.chunk(uploadedFiles, 12 / COLUMN_WIDTH);
    return rows.map((columns) => {
      const key = `${_.first(columns).pageIndex}-${_.last(columns).pageIndex}`;
      return (
        <div key={key} className="panel panel-default">
          <div className="panel-body">
            <Row>
              {columns.map(renderColumn)}
            </Row>
          </div>
        </div>
      );
    });
  };

  return (
    <React.Fragment>
      <div style={{ overflowY: 'auto', height: '45vh' }}>
        {renderRows()}
      </div>
      <Row>
        <Col md={12} className="app-center-text">
          <React.Fragment>
            <Button
              bsStyle="info"
              bsSize="large"
              onClick={() => { return onTypeChange('ticket'); }}
            >
              Ticket
            </Button>
            {' '}
            <Button
              bsStyle="warning"
              bsSize="large"
              onClick={showConfirmModal}
            >
              Split
            </Button>
          </React.Fragment>
        </Col>
      </Row>
    </React.Fragment>
  );
};


MultipageTypeLayout.propTypes = propTypes;


const SubmissionItemQuery = gql`
  query SubmissionItem($id: Int!) {
    submissionItem: submission_item(id: $id) {
      id
      document {
        id
        multipage
        uploadedFiles: uploaded_files {
          edges {
            node {
              id
              thumbnailUrl: thumbnail_url
              pageIndex: page_index
            }
          }
        }
      }
    }
  }
`;


const withSubmission = graphql(SubmissionItemQuery, {
  options: (props) => {
    return {
      variables: {
        id: props.selectedId,
      },
    };
  },
});


const mapDataToProps = withProps((props) => {
  const { data } = props;
  const uploadedFiles = querySelector(data, '$.submissionItem.document.uploadedFiles.edges[*].node', []);
  return {
    uploadedFiles,
  };
});


const withHide = branch(
  (props) => {
    return props.uploadedFiles === undefined;
  },
  renderNothing,
);


const enhance = compose(
  withSubmission,
  mapDataToProps,
  withHide,
  omitProps('data'),
);


export default enhance(MultipageTypeLayout);
